import { useCallback } from 'react';
import { last } from 'lodash';
import { useFormDataContext } from 'modules/taboola-common-frontend-modules/formData';
import { useLandingPagesApi } from 'services/api/landingPagesApi';
import { chatSender } from '../consts/chatState';

const merger = (_, data) => data;

export const useHandleChatSubmit = () => {
    const { chatEditLandingPage } = useLandingPagesApi();
    const { patchExternalData } = useFormDataContext();

    const chatSubmitHandler = async landingPage => {
        const { accountName, landingPageId, chatHistory = [] } = landingPage;
        const prompt = last(chatHistory)?.text ?? '';
        let newState;

        try {
            const { landingPage: newLandingPage, summary: newAiMessage } = await chatEditLandingPage({
                accountName,
                landingPageId,
                prompt,
            });
            newState = {
                ...newLandingPage,
                landingPageId,
                chatHistory: [...chatHistory, { sender: chatSender.ai, text: newAiMessage }],
            };
        } catch (error) {
            console.error(error);
            newState = {
                ...landingPage,
                chatHistory: [
                    ...chatHistory,
                    {
                        sender: chatSender.ai,
                        messageId: 'landing.pages.edit.chat.error.message',
                        defaultText: 'Something went wrong while editing the landing page. Please try again.',
                    },
                ],
            };
        }
        patchExternalData({ data: newState, merger });
        return newState;
    };

    return useCallback(chatSubmitHandler, [chatEditLandingPage, patchExternalData]);
};
